export const personType = {
  WORKER: {
    value: 'WORKER',
    label: '劳务工人'
  },
  MANAGER: {
    value: 'MANAGER',
    label: '管理人员'
  },
  OTHER: {
    value: 'OTHER',
    label: '其他人员'
  }
}
